/** Two initials for a person's disc; parenthesized demo labels are not names. */
export function initials(name: string): string {
  const parts = name.trim().replace(/\s*\([^)]*\)\s*$/, '').trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '·';
  const first = parts[0][0] ?? '';
  const second = parts.length > 1 ? (parts[1][0] ?? '') : '';
  return (first + second).toUpperCase();
}
